import { standardCachingQueryOptions } from 'pos-client/utils/standardCachingQueryOptions.ts';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useVehicle = ({ vehicleId }: { vehicleId?: string }) => {
  const response = trpc.getVehicleById.useQuery(
    {
      id: vehicleId as string,
    },
    {
      ...standardCachingQueryOptions,
      enabled: !!vehicleId,
    }
  );

  const { data, isLoading, isFetching, ...rest } = response;

  return {
    vehicle: data,
    isLoadingVehicle: isLoading,
    isFetchingVehicle: isFetching,
    ...rest,
  };
};
